module.exports = __webpack_public_path__ + "bin/1c8ca0a74aafa66e0258e409bcc241fb.jpg";